import React, { useState, useEffect } from "react";

// react-router-dom
import { useParams, useHistory } from "react-router-dom";

// react-helmet
import { Helmet } from "react-helmet";

// Components
import Gap from "../../../components/Gap";
import Divider from "../../../components/Divider";
import Add from "../../../assets/icon/add.svg";
import {
  analytics,
  FieldValue,
  firefunctions,
  // firestore,
  // analytics,
} from "../../../components/firebase/FirebaseProvider";

import Header from "../../../components/molecules/Header/";

import { useData } from "../../../components/firebase/DataProvider";
import ScrollContainer from "react-indiana-drag-scroll";

import ImageCarousel from "./ImageCarousel";
import DialogPilihAlamat from "./DialogPilihAlamat";
import slugify from "slugify";

// Material-UI
import {
  Button,
  Typography,
  // Divider,
  CircularProgress,
  AppBar,
  Card,
  CardActionArea,
  CardActions,
} from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Link from "@material-ui/core/Link";

// Styles
import useStyles from "./styles";

// Utils
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  // calculatePromo,
  arrayToCurrencyStringKomisi,
  calculatePromoLevel,
  calculateHargaLevel,
} from "../../../utils/currency";

import { findOnePromo } from "../../../utils/promo";

import { reduceVariants } from "../../../utils/reduceVariants";

import uniqBy from "lodash/uniqBy";

import {
  useDocumentData,
  useCollectionData,
} from "react-firebase-hooks/firestore";

import { productsCollection } from "../../../components/firebase/DataProvider";
import { upperFirst } from "lodash";
import { useSnackbar } from "notistack";
import YouTube from "react-youtube";
import CopyToClipboard from "react-copy-to-clipboard";
import SkeletonProduct from "../../../components/atoms/SkeletonProduct";
import Countdown from "react-countdown";

const CardProduct = ({
  item,
  index,
  toDetailProduct,
  promoF,
  emptyStock,
  textBadgePromo,
  total_stok,
  productValue,
  harga_normal,
  promoFound,
  harga_str_promo,
  harga_str,
  domain,
  bagikan,
}) => {
  const classes = useStyles();
  const { level, promo, global_komisi } = useData();

  const [newArrival, setNewArrival] = useState(false);

  useEffect(() => {
    const time = new Date();
    const timeSeconds = Math.round(time.getTime() / 1000);
    const timeNewArrival = item?.new_arrival?.seconds;
    const expiredTime = timeNewArrival - timeSeconds;
    if (expiredTime > 0) {
      setNewArrival(true);
    } else {
      setNewArrival(false);
    }
  }, []);

  const lowestPrice = Math.round(Math.min(...harga_normal));

  const all_komisi_str = arrayToCurrencyStringKomisi(
    lowestPrice,
    level.level,
    promoFound,
    global_komisi,
    productValue
  );

  return (
    <div className={classes.wrapper} key={index}>
      <Card className={classes.card}>
        <CardActionArea
          onClick={toDetailProduct(item?.id, item?.nama.toLowerCase())}
        >
          {promoF && !emptyStock ? (
            <div className={classes.labelCard}>
              <Typography className={classes.txtLabel}>
                {textBadgePromo}
              </Typography>
              <Typography className={classes.txtLabel}>OFF</Typography>
            </div>
          ) : null}
          {emptyStock ? (
            <div className={classes.empty}>
              <span className={classes.txtEmpty}>Stok Habis</span>
            </div>
          ) : null}
          {item?.thumbnail?.length > 0 ? (
            <div
              loading="lazy"
              // src={item.thumbnail[0]}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item?.thumbnail?.[0]})`,
              }}
            />
          ) : (
            <div
              loading="lazy"
              // src={item.thumbnail}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item?.thumbnail})`,
              }}
            />
          )}
          <div className={classes.contentWrapper}>
            <div className={classes.content}>
              <div style={{ display: "flex", marginBottom: 5 }}>
                {promoFound?.flash_sale || promoFound?.special_offer ? (
                  <div className={classes.labelFlash}>
                    {promoFound?.flash_sale ? "Flashsale" : "Special Offer"}
                  </div>
                ) : null}
                {item?.properties?.type === "preorder" &&
                item?.properties.end_at?.seconds * 1000 > Date.now() ? (
                  <div className={classes.labelPre}>Pre Order</div>
                ) : null}
                {newArrival && <div className={classes.labelNew}>Baru</div>}
              </div>
              <Typography className={classes.title} component="p">
                {item?.nama}
              </Typography>
              <Typography className={classes.txtStockTersedia} component="p">
                Stok tersedia
              </Typography>
              <Typography className={classes.txtStock} component="p">
                {total_stok > 100 ? "99+" : total_stok} pcs
              </Typography>
              <Typography className={classes.txtLabelharhag} component="p">
                Harga {upperFirst(level.level)}
              </Typography>
              {promo && (
                <Typography className={classes.price} component="p">
                  {promoFound ? harga_str_promo : harga_str}
                </Typography>
              )}
              <div className={classes.labelKomisi}>{all_komisi_str} Komisi</div>
            </div>
          </div>
        </CardActionArea>
        <CardActions>
          {emptyStock ? (
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              size="small"
              className={classes.btnCard}
              style={{
                backgroundColor: "rgb(255, 107, 107)",
              }}
            >
              Stok Habis
            </Button>
          ) : (
            <CopyToClipboard
              text={`${domain}/produk/${slugify(item.nama.toLowerCase())}/${
                item?.id_produk
              }`}
              onCopy={bagikan(item)}
            >
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="small"
                className={classes.btnCard}
                endIcon={<ShareIcon />}
              >
                Bagikan
              </Button>
            </CopyToClipboard>
          )}
        </CardActions>
      </Card>
    </div>
  );
};

export default function DetailProduk() {
  const classes = useStyles();

  const history = useHistory();

  const { nama, id } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const {
    webstore,
    webstoreRef,
    cart,
    cartRef,
    global_settings,
    promo,
    subdomain,
    level,
    global_komisi,
    preorderUtils,
  } = useData();

  const [variantIdSelected, setVariantIdSelected] = useState();

  const [variant1, setVariant1] = useState();

  const [submitting, setSubmitting] = useState(false);

  const [variant1Deps, setVariant1Deps] = useState();

  const [variant2, setVariant2] = useState();

  const [variant2Deps, setVariant2Deps] = useState();

  const [variantSelected, setVariantSelected] = useState({});

  const [product, setProduct] = useState({});

  const [products, setProducts] = useState([]);
  const [productsKat, setProductsKat] = useState([]);
  const [loadProducts, setLoadProducts] = useState(false);
  const [variantStock, setVariantStock] = useState();
  const domain = `https://${webstore.domain}.tokorame.store`;
  const produkType =
    product?.properties?.type === "preorder" ? "preorder" : "normal";

  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    type: "",
  });

  const productRef = productsCollection.doc(id);
  const variantsRef = productRef.collection("variants");
  const [productDB, loadingProduct] = useDocumentData(productRef, {
    idField: "id",
  });
  const [variants, loadingVariants] = useCollectionData(variantsRef, {
    idField: "id",
  });

  useEffect(() => {
    if (!loadingProduct && !loadingVariants) {
      if (productDB?.id) {
        setProduct({
          id: productDB?.id,
          ...productDB,
          variants: variants,
        });
      } else {
        enqueueSnackbar("Mohon Maaf Produk Tidak Ditemukan", {
          variant: "warning",
        });
        return history.goBack();
      }
    }
  }, [loadingProduct, loadingVariants, productDB, variants]);

  useEffect(() => {
    if (product?.brand?.nama && product.kategori3.nama && product.id) {
      async function getRelatedItems() {
        const arrVal = [
          { key: 1, label: "brand_nama", value: product?.brand?.nama },
          { key: 2, label: "kategori3_nama", value: product?.kategori3?.nama },
        ];
        try {
          setLoadProducts(true);
          await Promise.all(
            arrVal.map(async (val) => {
              const getRelatedProducts =
                firefunctions.httpsCallable("getRelatedProducts");
              const result = await getRelatedProducts({
                find_by_attr: val?.label,
                find_by_val: val?.value,
              });
              if (result.data.related_products?.length > 0) {
                let arr = [];
                await Promise.all(
                  result.data.related_products?.map(async (item) => {
                    const pro = await productsCollection
                      .doc(item.id_produk)
                      .get();
                    // console.log("b", await pro.ref.collection("variants").get());
                    if (!pro.empty && item.id_produk !== product.id) {
                      const variants = await pro.ref
                        .collection("variants")
                        .get();
                      const prodVariant = {
                        id: pro?.id,
                        id_produk: pro?.id,
                        ...pro?.data(),
                        variants: variants.docs.map((variant) => {
                          return {
                            id: variant.id,
                            ...variant.data(),
                          };
                        }),
                      };
                      // console.log("var",prodVariant);
                      arr.push(prodVariant);
                    }
                    // console.log("prod", arr);
                    if (val?.key === 1) {
                      setProducts([...arr]);
                    } else {
                      setProductsKat([...arr]);
                    }
                    // setProducts(arr);
                  })
                );
              } else {
                const query = await productsCollection
                  .where(val?.label?.replace("_", "."), "==", val?.value)
                  .limit(5)
                  .get();
                // console.log("a",query);
                if (!query.empty) {
                  const newProducts = await Promise.all(
                    query.docs.map(async (product) => {
                      const variants = await product.ref
                        .collection("variants")
                        .get();
                      return {
                        id: product?.id,
                        id_produk: product?.id,
                        ...product?.data(),
                        variants: variants.docs.map((variant) => {
                          return {
                            id: variant.id,
                            ...variant.data(),
                          };
                        }),
                      };
                    })
                  );
                  const filteredItems = newProducts.filter(
                    (item) => item.id_produk !== product?.id
                  );
                  if (val?.key === 1) {
                    setProducts([...filteredItems]);
                  } else {
                    setProductsKat([...filteredItems]);
                  }
                }
              }
            })
          );
          setLoadProducts(false);
        } catch (e) {
          setLoadProducts(false);
          console.log("error", e.message);
        }
      }
      getRelatedItems();
    }
  }, [product?.brand?.nama, product?.id, product?.kategori3?.nama]);

  useEffect(() => {
    setVariantStock(() => {
      let stock;

      if (variant1Deps?.length > 0) {
        stock = variant1Deps?.reduce((prev, curr) => {
          return prev + curr.stok_available;
        }, 0);
      } else if (variant2Deps?.length > 0) {
        stock = variant2Deps?.reduce((prev, curr) => {
          return prev + curr.stok_available;
        }, 0);
      }

      return stock;
    });
  }, [variant1Deps, variant2Deps]);

  const promoFound =
    loadingProduct || loadingVariants ? 0 : findOnePromo(product, promo);

  const toko = `Toko ${
    subdomain?.id?.charAt(0).toUpperCase() + subdomain?.id?.slice(1)
  }`;

  useEffect(() => {
    if (variantIdSelected && product) {
      const findVariant = product?.variants?.find(
        (variant) => variant.id === variantIdSelected
      );

      if (findVariant) {
        setVariantSelected(findVariant);
      } else {
        setVariantSelected({});
      }
    } else {
      setVariantSelected({});
    }
  }, [variantIdSelected, product]);

  if (!product.variants) {
    return (
      <div>
        <CircularProgress style={{ marginTop: "47.5%", marginLeft: "47.5%" }} />
      </div>
    );
  }

  const handleChangeVariant1 = (value, deps) => (e) => {
    if (variant1 === value) {
      setVariant1();
      setVariant2Deps();
      setVariant2();
      setVariantIdSelected();
    } else {
      setVariant1(value);
      setVariant2();
      setVariantIdSelected();
      setVariant2Deps(deps);
    }
  };

  const handleChangeVariant2 = (value, deps) => (e) => {
    if (variant2 === value) {
      setVariant2();
      setVariant1();
      setVariant1Deps();
      setVariantIdSelected();
    } else {
      setVariant2(value);
      setVariant1();

      setVariantIdSelected();
      setVariant1Deps(deps);
    }
  };

  const chooseVariantIDFromVariant1 = (value, id) => (e) => {
    if (variant1 === value) {
      setVariant1();
      setVariantIdSelected();
    } else {
      setVariant1(value);
      setVariantIdSelected(id);
    }
  };

  const chooseVariantIDFromVariant2 = (value, id) => (e) => {
    if (variant2 === value) {
      setVariant2();
      setVariantIdSelected();
    } else {
      setVariant2(value);
      setVariantIdSelected(id);
    }
  };

  const productThumbnails =
    product?.thumbnail?.reduce((prev, curr, index) => {
      return [
        ...prev,
        {
          key: product.id + "_" + index,
          id: product.id,
          thumbnail: curr,
          type: "product",
        },
      ];
    }, []) ?? [];

  const allVariantThumbnails =
    product?.variants?.reduce((prev, curr) => {
      const currentThumbs =
        curr.thumbnail?.map((thumb, index) => ({
          key: curr.id + "_" + index,
          id: curr.id,
          thumbnail: thumb,
          type: "variant",
        })) ?? [];
      return [...prev, ...currentThumbs];
    }, []) ?? [];

  const notUniqthumbnails = variantIdSelected
    ? variantSelected?.thumbnail?.length > 0
      ? variantSelected?.thumbnail?.map((thumb, index) => {
          return {
            key: variantIdSelected + "_" + index,
            id: variantIdSelected,
            thumbnail: thumb,
            type: "variant",
          };
        }) ?? []
      : [
          {
            key: variantIdSelected + "_" + 1,
            id: variantIdSelected,
            thumbnail:
              "https://www.generationsforpeace.org/wp-content/uploads/2018/03/empty.jpg",
            type: "variant",
          },
        ]
    : [...productThumbnails, ...allVariantThumbnails];

  const thumbnails = uniqBy(notUniqthumbnails, (value) => value.thumbnail);

  const productValue =
    product?.product_value !== undefined &&
    product?.product_value !== "" &&
    !Number.isNaN(product?.product_value) &&
    product?.product_value >= 0
      ? product?.product_value
      : 1;

  const formattedVariants = reduceVariants(product?.variants ?? []);

  const all_harga_normal = variantIdSelected
    ? variantSelected?.harga_normal
    : product?.variants?.map((variant) => variant[`harga_normal`]) ?? [];

  const all_harga_level = variantIdSelected
    ? calculateHargaLevel(
        variantSelected?.harga_normal,
        global_komisi,
        level?.level,
        productValue
      )
    : product?.variants?.map((variant) =>
        calculateHargaLevel(
          variant?.harga_normal,
          global_komisi,
          level?.level,
          productValue
        )
      ) ?? [];

  const all_harga_str = arrayToCurrencyString(all_harga_normal);

  const all_harga_str_level = arrayToCurrencyString(all_harga_level);

  const all_harga_str_promo =
    promoFound && arrayToCurrencyStringPromo(all_harga_normal, promoFound);

  const all_harga_str_promo_level =
    promoFound &&
    arrayToCurrencyStringPromo(
      all_harga_normal,
      promoFound,
      level.level,
      global_komisi,
      productValue
    );

  const all_komisi = variantIdSelected
    ? variantSelected?.harga_normal
    : product?.variants;

  const all_komisi_str = arrayToCurrencyStringKomisi(
    all_komisi,
    level.level,
    promoFound,
    global_komisi,
    productValue
  );
  const stokAll = product?.variants
    ?.filter((item) => item?.stok_available > 0)
    ?.reduce((prev, curr) => {
      return prev + curr.stok_available;
    }, 0);
  const stok_available = variantIdSelected
    ? variantSelected.stok_available
    : variantStock
    ? variantStock
    : stokAll > 100
    ? "99+"
    : stokAll;

  const sku = variantIdSelected ? variantSelected.sku : product?.brand?.nama;

  const handlePilihAlamat = () => {
    if (global_settings?.disable_order_creation) {
      setDialog({
        open: true,
        type: "info",
      });
    } else {
      setDialog({
        open: true,
        type: "cart",
      });
    }
  };
  // console.log(produkType);

  function getVolumeProduct(id) {
    const fieldAlamatOld = cart?.subcarts?.[id];
    let height = fieldAlamatOld?.height ? fieldAlamatOld?.height : 1;
    height =
      height > variantSelected?.tinggi_paket
        ? height
        : variantSelected?.tinggi_paket;

    let length = fieldAlamatOld?.length ? fieldAlamatOld?.length : 1;
    length =
      length > variantSelected?.panjang_paket
        ? length
        : variantSelected?.panjang_paket;

    let width = fieldAlamatOld?.width ? fieldAlamatOld?.width : 1;
    width =
      width > variantSelected?.lebar_paket
        ? width
        : variantSelected?.lebar_paket;

    const myObject = {
      height,
      length,
      width,
    };

    return { ...myObject };
  }

  const handleAddToCart = async (alamat) => {
    let dataProduk = Object.values(
      cart?.subcarts?.[alamat?.id]?.products ?? {}
    );

    if (dataProduk?.length > 0 && dataProduk?.[0]?.type !== produkType) {
      enqueueSnackbar(
        "Silahkan pilih alamat lain. Produk normal tidak bisa digabungkan dengan produk Pre-order",
        { variant: "warning" }
      );
    } else {
      setSubmitting(true);
      const { height, length, width } = getVolumeProduct(alamat?.id);
      const bayarOld = calculatePromoLevel(
        variantSelected?.harga_normal,
        promoFound,
        level.level,
        global_komisi,
        productValue
      );
      const bayar = Math.round(bayarOld);
      try {
        let isDownPayment =
          preorderUtils?.down_payment_option && produkType === "preorder"
            ? { payment_type: "down_payment" }
            : "";
        const isPreorder =
          produkType === "preorder" && preorderUtils?.down_payment_option
            ? {
                nilai_dp: Math.round(
                  (preorderUtils?.down_payment_percentage / 100) * bayar
                ),
              }
            : "";
        const data = {
          ...isDownPayment,
          subcarts: {
            [alamat.id]: {
              ...isPreorder,
              products: {
                [`${product.id}_${variantIdSelected}`]: {
                  nama: product.nama,
                  product: product.id,
                  jumlah: FieldValue.increment(1),
                  created_at: FieldValue.serverTimestamp(),
                  promo: promoFound?.id ?? "",
                  type: produkType,
                  start_preorder:
                    produkType === "preorder"
                      ? product?.properties?.start_at
                      : FieldValue.delete(),
                },
              },
              checked: "N",
              total_pembayaran: FieldValue.increment(bayar),
              total_tagihan: FieldValue.increment(bayar),
              berat_total: FieldValue.increment(variantSelected.berat_paket),
              total_tagihan_harga_normal: FieldValue.increment(
                variantSelected.harga_normal
              ),
              length,
              height,
              width,
              created_at: FieldValue.serverTimestamp(),
            },
          },
          type: "webseller",
          updated_at: FieldValue.serverTimestamp(),
        };

        if (!cart?.kode_order) {
          data.created_at = FieldValue.serverTimestamp();
          data.kode_order = `${subdomain?.id ?? "default"}-${Date.now()}`;
        }

        await cartRef.set(data, { merge: true });

        history.push("/cart");
      } catch (e) {
        console.log(e.message);
      }
      setSubmitting(false);
    }
  };

  const bagikan = (data) => async () => {
    setSubmitting(true);
    const findProductId = webstore.products?.includes?.(data.id);
    const checkDownpayment = preorderUtils?.down_payment_products?.includes(
      data.id
    );
    const downPaymentStatus =
      checkDownpayment && preorderUtils?.down_payment_option;

    if (!findProductId && !downPaymentStatus) {
      await webstoreRef.set(
        {
          products: FieldValue.arrayUnion(data.id),
        },
        { merge: true }
      );
      enqueueSnackbar("Link di salin", { variant: "success" });
    } else {
      enqueueSnackbar("Link di salin", { variant: "success" });
    }
    setSubmitting(false);
  };

  const toDetailProduct = (id, title) => () => {
    analytics.logEvent("view_product", { name: title, id: id });
    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  const opts = {
    height: "240",
    width: "320",
    playerVars: {
      rel: 0,
      autoplay: 0,
    },
  };

  const onReady = (event) => {
    event.target.pauseVideo();
  };

  const Renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <>
        {/* {days !== 0 ? ( */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 12,
            padding: "0px 10px",
          }}
        >
          <Typography className={classes.txt} color="secondary">
            {days > 0 ? (
              <>{days} hari lagi</>
            ) : (
              <>
                {hours > 9 ? hours : `0${hours}`} :{" "}
                {minutes > 9 ? minutes : `0${minutes}`} :{" "}
                {seconds > 9 ? seconds : `0${seconds}`}
              </>
            )}
          </Typography>
        </div>
        {/* ) : null} */}
      </>
    );
  };

  const RendererDays = ({ days }) => {
    return (
      <>
        <Typography className={classes.txtWhite}>
          {days > 9 ? days : `0${days}`} hari dari sekarang
        </Typography>
      </>
    );
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <title>
          {toko} | {nama}
        </title>
        <meta
          name="description"
          content={product && product?.deskripsi_singkat}
        />
        <meta property="og:title" content={`${nama} - ${toko}`} />
        <meta
          property="og:description"
          content={product && product.deskripsi_singkat}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={product && product?.thumbnail?.[0]}
        />
        <meta property="og:site_name" content={toko} />
        <meta
          property="og:url"
          content={`${window.location.origin}/produk/${nama}/${id}`}
        />
      </Helmet>
      <Header
        type="produk-detail"
        title={product?.nama}
        onClick={() => history.push("/")}
      />
      {/* <Gap height={60} /> */}
      <ImageCarousel thumbnails={thumbnails} />
      {produkType === "preorder" &&
      Date.now() < product?.properties?.end_at?.toMillis() ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: 10,
            backgroundColor: "#ECA059",
          }}
        >
          <div>
            <Typography className={classes.txtWhiteBold}>
              Est. Produk ready
            </Typography>
            <Countdown
              date={product?.properties?.ready_at?.toMillis()}
              renderer={RendererDays}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <Typography className={classes.txtWhite}>Berakhir dalam</Typography>
            <Countdown
              date={product?.properties?.end_at?.toMillis()}
              renderer={Renderer}
            />
          </div>
        </div>
      ) : (promoFound?.flash_sale || promoFound?.special_offer) &&
        Date.now() < promoFound?.end_at?.toMillis() ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: 10,
            backgroundColor: "#5675D3",
          }}
        >
          <div>
            <Typography className={classes.txtWhiteBold}>
              {promoFound?.flash_sale ? "Flashsale" : "Special Offer"}
            </Typography>
            <Typography className={classes.txtWhite}>
              checkout sekarang
            </Typography>
          </div>
          <div style={{ textAlign: "center" }}>
            <Typography className={classes.txtWhite}>Berakhir dalam</Typography>
            <Countdown
              date={promoFound?.end_at?.toMillis()}
              renderer={Renderer}
            />
          </div>
        </div>
      ) : null}
      <div className={classes.head}>
        {level?.is_active && (
          <Button className={classes.icon} disabled={submitting}>
            <img src={Add} alt="icon" onClick={bagikan(product)} />{" "}
          </Button>
        )}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div className={classes.label}>{sku}</div>
          <Gap width={6} />
          {stok_available <= 0 && (
            <div className={classes.label}>Stok Habis</div>
          )}
        </div>
        <Typography
          style={{
            textTransform: "capitalize",
            fontWeight: "bold",
            marginTop: 5,
          }}
        >
          {product?.nama}
        </Typography>
        {product?.properties?.type === "preorder" ? (
          ""
        ) : (
          <Typography
            color="secondary"
            component="small"
            style={{ fontSize: 13 }}
          >
            Stok Tersedia
          </Typography>
        )}
        <br />
        {product?.properties?.type === "preorder" ? (
          ""
        ) : (
          <div className={classes.descPrice}>
            <b style={{ color: "#F54C87" }}>
              {!stok_available <= 0 ? stok_available : 0}
            </b>
          </div>
        )}
      </div>
      <Divider />
      <div className={classes.priceWrapper}>
        <div className={classes.pricesList}>
          <div className={classes.sectionPrice}>
            <Typography component="small" className={classes.titlePrice}>
              Harga Konsumen
            </Typography>
            <br />
            <div style={{ display: "flex" }}>
              <div className={classes.descPrice}>
                {promoFound && (
                  <Typography
                    component="small"
                    style={{ marginRight: 10 }}
                    className={classes.priceProd}
                  >
                    {all_harga_str_promo}
                  </Typography>
                )}
                <Typography
                  className={classes.priceProd}
                  style={
                    promoFound && {
                      textDecoration: "line-through",
                      color: "gray",
                    }
                  }
                >
                  {all_harga_str}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.sectionPrice}>
            <Typography component="small" className={classes.titlePrice}>
              {`Harga ${upperFirst(level.level)}`}
            </Typography>
            <br />
            <div style={{ display: "flex" }}>
              <div className={classes.descPrice}>
                {promoFound && (
                  <Typography
                    component="small"
                    style={{ marginRight: 10 }}
                    className={classes.priceProd}
                  >
                    {all_harga_str_promo_level}
                  </Typography>
                )}
                <Typography
                  className={classes.priceProd}
                  style={
                    promoFound && {
                      textDecoration: "line-through",
                      color: "gray",
                    }
                  }
                >
                  {all_harga_str_level}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.sectionPrice}>
            <Typography component="small" className={classes.titlePrice}>
              Komisi
            </Typography>
            <br />
            <div style={{ display: "flex" }}>
              <div className={classes.descPrice}>
                <Typography component="small" className={classes.priceProd}>
                  {all_komisi_str}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.sectionPrice}>
            <div className={classes.labelKomisi}>
              {Math.round(global_komisi?.[level?.level] * productValue * 100)}%
              Komisi
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <div className={classes.variantContent}>
        <Typography component="h3" className={classes.h3Title}>
          Pilih {product?.variant1_label}
        </Typography>
        {variant1Deps ? (
          <div className={classes.row}>
            {variant1Deps.map((item) => {
              const isSelected = variant1 === item.variant1_value;
              if (item.stok_available <= 0) {
                return null;
              } else {
                return (
                  <Button
                    key={item.variant1_value}
                    onClick={chooseVariantIDFromVariant1(
                      item.variant1_value,
                      item.id
                    )}
                    disabled={submitting}
                    style={
                      isSelected
                        ? {
                            borderRadius: 100,
                            marginRight: 10,
                            marginBottom: 15,
                            color: "#5675D3",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // fontWeight: "bold",
                            fontSize: 10,
                            backgroundColor: "#E4F1FF",
                            minWidth: 90,
                            borderWidth: 0,
                          }
                        : {
                            borderRadius: 100,
                            marginRight: 10,
                            marginBottom: 15,
                            color: "grey",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // fontWeight: "bold",
                            fontSize: 10,
                            backgroundColor: "#EFEFEF",
                            minWidth: 90,
                            borderWidth: 0,
                          }
                    }
                    // variant={isSelected ? "contained" : "outlined"}
                    // classes={{ root: classes.btnt }}
                    // color="primary"
                    // className={
                    //   isSelected ? classes.btnSelect : classes.btnSelectSelected
                    // }
                  >
                    {item.variant1_value?.toUpperCase?.() ??
                      item.variant1_value}
                  </Button>
                );
              }
            })}
          </div>
        ) : (
          <div className={classes.row}>
            {Object.keys(formattedVariants?.variant1_values ?? {}).map(
              (val) => {
                const deps = formattedVariants?.variant1_values[val];
                const isSelected = variant1 === val;
                let stok = deps.reduce((prev, curr) => {
                  return (
                    prev + (curr.stok_available >= 0 ? curr.stok_available : 0)
                  );
                }, 0);
                if (stok <= 0) {
                  return null;
                } else {
                  return (
                    <Button
                      key={val}
                      onClick={handleChangeVariant1(val, deps)}
                      // variant={isSelected ? "contained" : "outlined"}
                      // classes={{ root: classes.btnt }}
                      disabled={submitting}
                      style={
                        isSelected
                          ? {
                              borderRadius: 100,
                              marginRight: 10,
                              marginBottom: 15,
                              color: "#5675D3",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              // fontWeight: "bold",
                              fontSize: 10,
                              backgroundColor: "#E4F1FF",
                              minWidth: 90,
                              borderWidth: 0,
                            }
                          : {
                              borderRadius: 100,
                              marginRight: 10,
                              marginBottom: 15,
                              color: "grey",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              // fontWeight: "bold",
                              fontSize: 10,
                              backgroundColor: "#EFEFEF",
                              minWidth: 90,
                              borderWidth: 0,
                            }
                      }
                      // color="default"
                      // className={
                      //   isSelected
                      //     ? classes.btnSelect
                      //     : classes.btnSelectSelected
                      // }
                    >
                      {val?.toUpperCase?.() ?? val}
                    </Button>
                  );
                }
              }
            )}
          </div>
        )}
        {/* <Gap height={16} /> */}
        <Typography component="h3" className={classes.h3Title}>
          Pilih {product?.variant2_label}
        </Typography>
        {variant2Deps ? (
          <div className={classes.row}>
            {variant2Deps.map((item) => {
              const isSelected = variant2 === item.variant2_value;
              if (item.stok_available <= 0) {
                return null;
              } else {
                return (
                  <Button
                    key={item.variant2_value}
                    onClick={chooseVariantIDFromVariant2(
                      item.variant2_value,
                      item.id
                    )}
                    disabled={submitting}
                    // variant={isSelected ? "contained" : "outlined"}
                    // classes={{ root: classes.btnt }}
                    // color="primary"
                    // className={
                    //   isSelected ? classes.btnSelect : classes.btnSelectSelected
                    // }
                    style={
                      isSelected
                        ? {
                            borderRadius: 100,
                            marginRight: 10,
                            marginBottom: 15,
                            color: "#5675D3",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // fontWeight: "bold",
                            fontSize: 10,
                            backgroundColor: "#E4F1FF",
                            minWidth: 90,
                            borderWidth: 0,
                          }
                        : {
                            borderRadius: 100,
                            marginRight: 10,
                            marginBottom: 15,
                            color: "grey",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // fontWeight: "bold",
                            fontSize: 10,
                            backgroundColor: "#EFEFEF",
                            minWidth: 90,
                            borderWidth: 0,
                          }
                    }
                  >
                    {item.variant2_value?.toUpperCase?.() ??
                      item.variant2_value}
                  </Button>
                );
              }
            })}
          </div>
        ) : (
          <div className={classes.row}>
            {Object.keys(formattedVariants?.variant2_values ?? {}).map(
              (val) => {
                const deps = formattedVariants?.variant2_values[val];
                const isSelected = variant2 === val;
                let stok = deps.reduce((prev, curr) => {
                  return (
                    prev + (curr.stok_available >= 0 ? curr.stok_available : 0)
                  );
                }, 0);
                if (stok <= 0) {
                  return null;
                } else {
                  return (
                    <Button
                      key={val}
                      onClick={handleChangeVariant2(val, deps)}
                      // variant={isSelected ? "contained" : "outlined"}
                      // classes={{ root: classes.btnt }}
                      disabled={submitting}
                      // color="primary"
                      // className={
                      //   isSelected
                      //     ? classes.btnSelect
                      //     : classes.btnSelectSelected
                      // }
                      style={
                        isSelected
                          ? {
                              borderRadius: 100,
                              marginRight: 10,
                              marginBottom: 15,
                              color: "#5675D3",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              // fontWeight: "bold",
                              fontSize: 10,
                              backgroundColor: "#E4F1FF",
                              minWidth: 90,
                              borderWidth: 0,
                            }
                          : {
                              borderRadius: 100,
                              marginRight: 10,
                              marginBottom: 15,
                              color: "grey",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              // fontWeight: "bold",
                              fontSize: 10,
                              backgroundColor: "#EFEFEF",
                              minWidth: 90,
                              borderWidth: 0,
                            }
                      }
                    >
                      {val?.toUpperCase?.() ?? val}
                    </Button>
                  );
                }
              }
            )}
          </div>
        )}
      </div>
      <Divider />
      <div>
        <div className={classes.descHead}>
          <b>Deskripsi Produk</b>
        </div>
        {product?.video_id ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 10 }}
          >
            <YouTube
              videoId={product?.video_id}
              opts={opts}
              onReady={onReady}
            />
          </div>
        ) : null}
        {product?.link_foto ? (
          <div style={{ padding: "0px 16px 16px" }}>
            <Link href={product?.link_foto} target="_blank">
              Link Foto Product
            </Link>
          </div>
        ) : (
          ""
        )}

        <div className={classes.descBody}>{product?.deskripsi_lengkap}</div>
      </div>
      <Divider />
      <div>
        <div className={classes.descHead}>
          <b>Produk Lain Dari Brand {product?.brand?.nama}</b>
        </div>
        {loadProducts ? (
          <SkeletonProduct />
        ) : (
          <>
            {products?.length <= 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  width: "100%",
                  marginBottom: "25px",
                }}
              >
                <p>
                  <b>Produk Tidak Ditemukan</b>
                </p>
              </div>
            ) : (
              <ScrollContainer className={classes.wrapScroll}>
                {products?.map((item, index) => {
                  const stok = item.variants.map(
                    (variant) => variant.stok_available
                  );

                  const productValue = item?.product_value
                    ? item?.product_value
                    : 1;

                  const harga = item.variants.map((variant) =>
                    calculateHargaLevel(
                      variant?.harga_normal,
                      global_komisi,
                      level?.level,
                      productValue
                    )
                  );

                  const harga_normal = item.variants.map(
                    (variant) => variant?.harga_normal
                  );

                  const promoFound = findOnePromo(item, promo);

                  const total_stok = stok.reduce((val, nilaiSekarang) => {
                    return val + nilaiSekarang;
                  }, 0);

                  const emptyStock = total_stok === 0 ? true : false;

                  const harga_str = arrayToCurrencyString(harga);
                  const promoF = promoFound ? true : false;

                  const harga_str_promo =
                    promoFound &&
                    arrayToCurrencyStringPromo(
                      harga_normal,
                      promoFound,
                      level.level,
                      global_komisi,
                      productValue
                    );

                  const textBadgePromo = (() => {
                    let text = "";

                    if (promoFound) {
                      if (promoFound?.tipe === "%") {
                        text = `${promoFound?.nilai}%`;
                      } else {
                        text = `${promoFound?.nilai / 1000}K`;
                      }
                    }

                    return text;
                  })();

                  return (
                    <CardProduct
                      item={item}
                      index={index}
                      toDetailProduct={toDetailProduct}
                      textBadgePromo={textBadgePromo}
                      productValue={productValue}
                      harga_normal={harga_normal}
                      bagikan={bagikan}
                      promoFound={promoFound}
                      promoF={promoF}
                      harga_str_promo={harga_str_promo}
                      harga_str={harga_str}
                      domain={domain}
                      total_stok={total_stok}
                      emptyStock={emptyStock}
                    />
                  );
                })}
              </ScrollContainer>
            )}
          </>
        )}
      </div>
      <Divider />
      <div>
        <div className={classes.descHead}>
          <b>Produk Lain Dari Kategori {product?.kategori3?.nama}</b>
        </div>
        {loadProducts ? (
          <SkeletonProduct />
        ) : (
          <>
            {productsKat?.length <= 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  width: "100%",
                  marginBottom: "25px",
                }}
              >
                <p>
                  <b>Produk Tidak Ditemukan</b>
                </p>
              </div>
            ) : (
              <ScrollContainer className={classes.wrapScroll}>
                {productsKat?.map((item, index) => {
                  const stok = item.variants.map(
                    (variant) => variant.stok_available
                  );

                  const productValue = item?.product_value
                    ? item?.product_value
                    : 1;

                  const harga = item.variants.map((variant) =>
                    calculateHargaLevel(
                      variant?.harga_normal,
                      global_komisi,
                      level?.level,
                      productValue
                    )
                  );

                  const harga_normal = item.variants.map(
                    (variant) => variant?.harga_normal
                  );

                  const promoFound = findOnePromo(item, promo);

                  const total_stok = stok.reduce((val, nilaiSekarang) => {
                    return val + nilaiSekarang;
                  }, 0);

                  const emptyStock = total_stok === 0 ? true : false;

                  const harga_str = arrayToCurrencyString(harga);
                  const promoF = promoFound ? true : false;

                  const harga_str_promo =
                    promoFound &&
                    arrayToCurrencyStringPromo(
                      harga_normal,
                      promoFound,
                      level.level,
                      global_komisi,
                      productValue
                    );

                  const textBadgePromo = (() => {
                    let text = "";

                    if (promoFound) {
                      if (promoFound?.tipe === "%") {
                        text = `${promoFound?.nilai}%`;
                      } else {
                        text = `${promoFound?.nilai / 1000}K`;
                      }
                    }

                    return text;
                  })();

                  return (
                    <CardProduct
                      item={item}
                      index={index}
                      toDetailProduct={toDetailProduct}
                      textBadgePromo={textBadgePromo}
                      productValue={productValue}
                      harga_normal={harga_normal}
                      bagikan={bagikan}
                      promoFound={promoFound}
                      promoF={promoF}
                      harga_str_promo={harga_str_promo}
                      harga_str={harga_str}
                      domain={domain}
                      total_stok={total_stok}
                      emptyStock={emptyStock}
                    />
                  );
                })}
              </ScrollContainer>
            )}
          </>
        )}
      </div>
      <div style={{ marginBottom: "75px" }}></div>
      <AppBar
        position="fixed"
        // color="default"
        style={{
          bottom: "0",
          top: "auto",
          backgroundColor: "#fafafa",
          maxWidth: "960px",
          left: "auto",
          right: "auto",
        }}
      >
        <div style={{ display: "flex", padding: "15px" }}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            style={{
              marginRight: "5px",
              // backgroundColor: "#27AE60",
              // color: "white",
            }}
            className={classes.btn}
            disabled={submitting}
            onClick={bagikan(product)}
            startIcon={<ShareIcon color="primary" />}
          >
            Bagikan
          </Button>
          {produkType === "preorder" ? (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.btn}
              style={{ marginLeft: "5px", color: "white" }}
              onClick={handlePilihAlamat}
              disabled={
                submitting ||
                !variantIdSelected ||
                stok_available <= 0 ||
                product?.sembunyikan_produk ||
                !product?.properties?.orderable
              }
              startIcon={<ShoppingCartIcon />}
            >
              {product?.sembunyikan_produk || stok_available <= 0
                ? "Stok Tidak Tersedia"
                : "Preorder"}
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.btn}
              style={{ marginLeft: "5px", color: "white" }}
              onClick={handlePilihAlamat}
              disabled={
                submitting ||
                !variantIdSelected ||
                stok_available <= 0 ||
                product?.sembunyikan_produk
              }
              startIcon={<ShoppingCartIcon />}
            >
              {product?.sembunyikan_produk || stok_available <= 0
                ? "Stok Tidak Tersedia"
                : "Beli"}
            </Button>
          )}
          <Gap height={12} />
        </div>
      </AppBar>
      <DialogPilihAlamat
        open={dialog.open}
        handleClose={() => setDialog({ open: false, title: "", type: "" })}
        addToCart={handleAddToCart}
        submitting={submitting}
        title={dialog.title}
        type={dialog.type}
      />
    </div>
  );
}
